module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-0f9b8a.44663b10.png";